import { useNavigate, useLocation } from "@tanstack/react-router";
import { SearchX } from "lucide-react";

export const NotFoundComponent = ({ homePath }: { homePath?: string }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Determine the appropriate home path based on current location
  const getHomePath = () => {
    if (homePath) {
      return homePath;
    }

    const currentPath = location.pathname;
    if (currentPath.startsWith("/provider/")) {
      return "/provider/home";
    } else if (currentPath.startsWith("/org/")) {
      const orgIdMatch = currentPath.match(/^\/org\/([0-9a-f-]+)\//);
      if (orgIdMatch) {
        return `/org/${orgIdMatch[1]}/home`;
      }
      return "/org/home";
    }

    // Default fallback
    return "/";
  };

  const resolvedHomePath = getHomePath();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-8 text-center">
      <div className="rounded-full bg-blue-100 p-4 mb-6">
        <SearchX className="w-12 h-12 text-blue-500" />
      </div>
      <h1 className="text-3xl font-bold mb-3">404 - Page Not Found</h1>
      <p className="text-gray-600 mb-6 max-w-md">
        The page you are looking for might have been removed, had its name
        changed, or is temporarily unavailable.
      </p>
      <button
        onClick={() => navigate({ to: resolvedHomePath })}
        className="px-4 py-2 bg-primary text-white rounded-md hover:bg-primary/90 transition-colors"
      >
        Return to Home
      </button>
    </div>
  );
};
